const API_BASE = '/api';

function extractErrorMessage(data, status) {
  if (!data || typeof data !== 'object') {
    return `请求失败 (${status})`;
  }
  if (typeof data.error === 'string' && data.error) {
    return data.error;
  }
  const detail = data.detail;
  if (typeof detail === 'string' && detail) {
    return detail;
  }
  if (Array.isArray(detail) && detail.length) {
    const first = detail[0];
    if (typeof first === 'string') return first;
    if (first && typeof first.msg === 'string') return first.msg;
  }
  return `请求失败 (${status})`;
}

async function request(path, options = {}) {
  const { method = 'GET', body, headers, ...rest } = options;
  const response = await fetch(`${API_BASE}${path}`, {
    method,
    body,
    headers: { 'Content-Type': 'application/json', ...(headers || {}) },
    ...rest,
  });
  let data;
  try {
    data = await response.json();
  } catch {
    return { ok: false, error: `请求失败 (${response.status})` };
  }
  if (data.ok === false) {
    return { ok: false, error: extractErrorMessage(data, response.status) };
  }
  if (!response.ok) {
    return { ok: false, error: extractErrorMessage(data, response.status) };
  }
  return data;
}

async function uploadFile(path, file) {
  const form = new FormData();
  form.append('file', file, file.name);
  form.append('original_name', file.name);
  let response;
  try {
    response = await fetch(`${API_BASE}${path}`, { method: 'POST', body: form });
  } catch {
    return { ok: false, error: '网络异常，上传失败' };
  }
  let data;
  try {
    data = await response.json();
  } catch {
    return { ok: false, error: `上传失败 (${response.status})` };
  }
  if (data.ok === false) {
    return { ok: false, error: extractErrorMessage(data, response.status) };
  }
  if (!response.ok) {
    return { ok: false, error: extractErrorMessage(data, response.status) };
  }
  return data;
}

export const materialCheckApi = {
  getState: () => request('/state'),
  uploadSettlement: (file) => uploadFile('/settlement/upload', file),
  uploadMaterial: (file) => uploadFile('/material/upload', file),
  setProject: (choice) => request('/project', { method: 'POST', body: JSON.stringify({ choice }) }),
  configureMaterial: (sheetName, mapping) =>
    request('/material/configure', {
      method: 'POST',
      body: JSON.stringify({ sheetName, mapping: mapping || null }),
    }),
  previewSettlement: (limit = 100) =>
    request('/settlement/preview', { method: 'POST', body: JSON.stringify({ limit }) }),
  previewMaterial: (limit = 100) =>
    request('/material/preview', { method: 'POST', body: JSON.stringify({ limit }) }),
  clearSettlement: () => request('/reset', { method: 'POST', body: JSON.stringify({ scope: 'settlement' }) }),
  clearMaterial: () => request('/reset', { method: 'POST', body: JSON.stringify({ scope: 'material' }) }),
  resetAll: () => request('/reset', { method: 'POST', body: JSON.stringify({ scope: 'all' }) }),
  generateSumReport: () => request('/reports/sum', { method: 'POST' }),
  generateConditionalSumReport: () => request('/reports/conditional-sum', { method: 'POST' }),
  generateCheckReport: () => request('/reports/check', { method: 'POST' }),
};
